export const environment = {
  production: false,
  strapiUrl: 'https://api.sklep.levicare.pl',
  shapecareApiUrl: 'https://rails.shape.care'
};
